import VariantPriceController from './controllers/VariantPriceController';
import LoginButtonController from './controllers/LoginButtonController';

/**
 * Constructor for the product module
 *
 * @return {void}
 */
const init = () => {
  VariantPriceController();
  LoginButtonController();
};

export default init;


// WEBPACK FOOTER //
// ./src/js/modules/product/Module.js